import api from "@/api";

export interface ListaPrecioItem {
  producto_id: string;
  codigo?: string | null;
  nombre: string;
  precio_final: number;
}

export interface ListaPrecio {
  _id: string;
  nombre: string;
  activo: boolean;
  es_default: boolean;
  items: ListaPrecioItem[];
}

export interface ListaPrecioPayload {
  nombre: string;
  activo: boolean;
  items: ListaPrecioItem[];
}

export interface PrecioProductoLista {
  lista_precio_id: string;
  lista_precio_nombre: string;
  producto_id: string;
  codigo?: string | null;
  nombre: string;
  precio_final: number;
  precio_unitario: number;
  iva: number;
}

export const ListasPreciosApi = {
  listar: () => api.get("/listas_precios").then((r) => r.data),
  obtener: (id: string) => api.get(`/listas_precios/${id}`).then((r) => r.data),
  crear: (payload: ListaPrecioPayload) =>
    api.post("/listas_precios", payload).then((r) => r.data),
  actualizar: (id: string, payload: ListaPrecioPayload) =>
    api.put(`/listas_precios/${id}`, payload).then((r) => r.data),
  marcarDefault: (id: string) =>
    api.post(`/listas_precios/${id}/default`).then((r) => r.data),
  asignarCliente: (clienteId: string, listaPrecioId: string | null) =>
    api
      .post(`/listas_precios/asignar-cliente/${clienteId}`, {
        lista_precio_id: listaPrecioId,
      })
      .then((r) => r.data),
  obtenerPrecio: (params: {
    cliente_id?: string;
    lista_precio_id?: string;
    producto_id?: string;
    codigo?: string;
  }) => api.get("/listas_precios/precio", { params }).then((r) => r.data),
};

export function isMissingListPriceError (error: any): boolean {
  return Number(error?.response?.status) === 404
}
